import React, { useState } from "react";

import { Paper, useTheme } from "@mui/material";

import { useTranslation } from "react-i18next";

import { WithOptionsWidgetProps } from "components/widgetParts/withOptionsWidget";
import SplitSettingsWrapper from "components/settingsConfig/SplitSettingsWrapper";
import SettingsOptions from "components/settingsConfig/SettingsOptions";
import SettingsColorPicker from "components/settingsConfig/uiComponents/SettingsColorPicker";
import HeadlinePreview from "./HeadlinePreview";
import SettingsTextField from "components/settingsConfig/uiComponents/SettingsTextField";
import SimpleFormDialog from "components/dialogs/SimpleFormDialog";

export type HeadlineSettingsStateType = {
  backgroundColor: string;
  headlineColor: string;
  headlineSubtext: string;
  headlineTitle: string;
  subtextColor: string;
}

export const defaultSettings: HeadlineSettingsStateType = {
  backgroundColor: '',
  headlineColor: '',
  headlineSubtext: '',
  headlineTitle: '',
  subtextColor: ''
}

export function HeadlineSettingsDialog(props: WithOptionsWidgetProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();

  // check if the data object has the fields needed
  const updateWidgetData = () => {
    if (props.widget?.id && props.onUpdateWidgetData) {
      props.onUpdateWidgetData(props.widget?.id, {
        settings: settingsState
      }).then(() => {
        if (props.widgetRefresh) {
          props.widgetRefresh();
        }
      });
    }
  }

  const [settingsState, setSettingsState] = useState<HeadlineSettingsStateType>({
    ...defaultSettings,
    ...props?.widget?.data,
    ...props?.widget?.data?.settings
  });
  const settingsOnChange = (updatedState: HeadlineSettingsStateType) => setSettingsState(updatedState);

  return (
  <SimpleFormDialog
    fullWidth={true}
    isOpen={true}
    maxWidth="md"
    onCancel={() => props.setSettingsDialogIsOpen(false)}
    onConfirm={() => {
      updateWidgetData();
      props.setSettingsDialogIsOpen(false);
    }}
    title={i18n.t("widget-types.headline.settings.title")}>
    <Paper sx={{ p: 2, pt: 0.5 }}>
      <SplitSettingsWrapper>
        <HeadlinePreview settingsState={settingsState} />
        <SettingsOptions onChange={settingsOnChange} settingsState={settingsState}>
          <SettingsTextField
            keyid="headlineTitle"
            label={i18n.t("widget-types.headline.settings.headline")}
            value={settingsState.headlineTitle} />
          <SettingsTextField
            keyid="headlineSubtext"
            label={i18n.t("widget-types.headline.settings.subheadline")}
            value={settingsState.headlineSubtext} />
          <SettingsColorPicker
            color={settingsState.headlineColor}
            defaultColor={theme.palette.text.primary}
            keyid="headlineColor"
            label={i18n.t("widget-types.headline.settings.headline-color")} />
          <SettingsColorPicker
            color={settingsState.subtextColor}
            defaultColor={theme.palette.text.primary}
            keyid="subtextColor"
            label={i18n.t("widget-types.headline.settings.subheadline-color")} />
          <SettingsColorPicker
            color={settingsState.backgroundColor}
            keyid="backgroundColor"
            label={i18n.t("background-color")} />
        </SettingsOptions>
      </SplitSettingsWrapper>
    </Paper>
  </SimpleFormDialog>
  )
}